import styled from 'styled-components/macro';

const ContentWrapper = styled.div`
  padding: 0px 10px 50px;
`;

const ActionsButtonsWrapper = styled.div`
  padding: 18px 30px;
  bottom: 0px;
  top: ${window.document.body.offsetHeight >= window.innerHeight ? '100vh' : 'auto'};
  left: 0px;
  right: 0px;
  position: sticky;
  background-color: #ffffff;
  width: 100%;
  min-height: 65px;
  box-shadow: 0px -4px 15px rgba(23, 45, 70, 0.08);
`;

export { ContentWrapper, ActionsButtonsWrapper };
